import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { ErrorGlobal } from '@xingternal/content-error';
import { StaticTerms } from './StaticTerms';
import { AppRoutes } from '../../RoutesConfig';
import styles from './Terms.css';
import { RootState } from '../../redux';
import ContainedGrid from '@xingternal/xing-grid';

const RawTermsPage = (): React.ReactElement => {
  const { entity: pages, error } = useSelector<
    RootState,
    RootState['publicPages']
  >(state => {
    return state.publicPages;
  });

  const { formatMessage } = useIntl();
  const title = formatMessage({ id: 'LEGAL_PAGES_TERMS_AND_CONDITIONS_TITLE' });

  return (
    <>
      <Helmet title={[title, 'XING'].join(' | ')} />

      {error && <ErrorGlobal type="503" />}
      {pages && (
        <ContainedGrid type="standard">
          <div className={styles.container}>
            <StaticTerms
              pages={pages}
              pageLink={(page): string =>
                AppRoutes.public.publicTermDetails(page.slug)
              }
            />
          </div>
        </ContainedGrid>
      )}
    </>
  );
};

export const TermsPage = RawTermsPage;
